export default "__VITE_ASSET__Cwn9GQrf__"